import { useAccount } from 'wagmi';
import { useWalletList } from './use-wallet-list';
import { useSubscription } from './use-subscription';
import { useAuth } from './use-auth';

export type AccessLevel = 'none' | 'connected' | 'full';

export interface AccessState {
  level: AccessLevel;
  isConnected: boolean;
  isAuthenticated: boolean;
  isPremium: boolean;
  isAdmin: boolean;
  hasWallets: boolean;
  walletCount: number;
  address: string | undefined;
}

export function useAccess(): AccessState {
  const { isConnected: wagmiConnected, address: wagmiAddress } = useAccount();
  const { isAuthenticated, authenticatedAddress } = useAuth();

  // Prefer Privy-authenticated address — wagmi isConnected is unreliable with
  // Privy embedded wallets which don't always register with the wagmi connector.
  const address = authenticatedAddress ?? wagmiAddress;
  const isConnected = !!address || wagmiConnected;

  const { additionalWallets } = useWalletList(address);
  const { isPremium, isAdmin } = useSubscription();

  const hasWallets = additionalWallets.length >= 1;
  const level: AccessLevel = !isConnected ? 'none' : 'full';

  return {
    level,
    isConnected,
    isAuthenticated,
    isPremium,
    isAdmin,
    hasWallets,
    walletCount: additionalWallets.length,
    address,
  };
}
